"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicrophoneVolumeBar = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _MicrophoneVolumeBar = require("./MicrophoneVolumeBar.styled");
var _utils = require("../../utils");
var _excluded = ["selectedGroupId"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MicrophoneVolumeBar = exports.MicrophoneVolumeBar = function MicrophoneVolumeBar(_ref) {
  var selectedGroupId = _ref.selectedGroupId,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    volume = _useState2[0],
    setVolume = _useState2[1];
  var filled = Math.round(volume / 10);
  var length = 10;
  var boxes = Array.from({
    length: length
  });
  var boxColor = '#0095FF';
  (0, _react.useEffect)(function () {
    var audioContext = new AudioContext();
    var setupVolumeMeter = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var callback;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!selectedGroupId) {
                _context.next = 5;
                break;
              }
              callback = function callback(_volume) {
                if (volume === _volume) return;
                setVolume(_volume);
              };
              _context.next = 5;
              return (0, _utils.getVolumeFromGroupId)(selectedGroupId, callback, audioContext);
            case 5:
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error('Error setting up volume meter:', _context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      return function setupVolumeMeter() {
        return _ref2.apply(this, arguments);
      };
    }();
    setupVolumeMeter();
    return function () {
      audioContext.close();
    };
  }, [selectedGroupId]);
  if (!selectedGroupId) return null;
  return /*#__PURE__*/_react["default"].createElement(_MicrophoneVolumeBar.StyledOutputLevel, (0, _extends2["default"])({
    "data-volume": volume,
    role: "meter",
    "aria-valuenow": volume,
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-live": "off",
    title: "Microphone volume - ".concat(volume, "%")
  }, props), boxes.map(function (box, index) {
    return /*#__PURE__*/_react["default"].createElement(_MicrophoneVolumeBar.OutputIndicator, {
      key: index + boxColor,
      isActive: index < filled,
      color: boxColor
    });
  }));
};